let $filters = null;
let $filtersOverlay = null;

export const init = () => {

  $filters = $('#filters-list');
  $filtersOverlay = $('#filters-overlay');

  $(document).on('click', '#filters-open-button', openFilters);
  $(document).on('click', '#filters-close-button', closeFilters);

};

const openFilters = () => {
  if (!$filters.hasClass('workshop-aside__filters--open')) {
    $filters.addClass('workshop-aside__filters--open');
    $filtersOverlay.addClass('workshop-aside__filters__overlay--open');
  }
};

const closeFilters = () => {
  if ($filters.hasClass('workshop-aside__filters--open')) {
    $filters.removeClass('workshop-aside__filters--open');
    $filtersOverlay.removeClass('workshop-aside__filters__overlay--open');
  }
};


// WEBPACK FOOTER //
// ./src/workshop/workshop-services.js